import jwt_decode from 'jwt-decode';

export interface JwtClaims {
  IsSuperUser: string;
  IsActive: string;
  Sites: string[];
  IsSandboxUser: string;
}

export interface ClaimsSite {
  FullURL: string;
  SiteId: string;
}

export interface UserDetailClaims {
  FirstName: string;
  LastName: string;
  Email: string;
  UserName: string;
}

export const isSuperUser = (jwtToken: string): boolean => {
  const claims = jwt_decode<JwtClaims>(jwtToken);

  return claims.IsSuperUser.toUpperCase() === 'TRUE';
};

export const isSandboxUser = (jwtToken: string): boolean => {
  const claims = jwt_decode<JwtClaims>(jwtToken);
  return claims.IsSandboxUser.toUpperCase() === 'TRUE';
};

export const getUserDetails = (jwtToken: string): UserDetailClaims => {
  const claims = jwt_decode<UserDetailClaims>(jwtToken);

  return {
    FirstName: claims.FirstName,
    LastName: claims.LastName,
    Email: claims.Email,
    UserName: claims.UserName
  };
};
